import { TProcessBoardsActions } from './process-boards.actions';
import { TProcessBoardsActionType, TProcessBoardsState } from './process-boards.models';

export const initialState: TProcessBoardsState = {
  capacityBoardInfo: null,
  capacityBoardFetchState: 'loading',
  planningBoardInfo: null,
  planningBoardFetchState: 'loading',
  orderTimelineViewBoardInfo: null,
  orderTimelineViewBoardFetchState: 'loading',
  selectedProcessId: null,
  allProcesses: [],
};

export function processBoardsReducer(state = initialState, action: TProcessBoardsActions): TProcessBoardsState {
  switch (action.type) {
    case TProcessBoardsActionType.FetchCapacityBoardListing:
      return { ...state, capacityBoardFetchState: 'loading' };
    case TProcessBoardsActionType.FetchCapacityBoardListingSuccess:
      return {
        ...state,
        capacityBoardInfo: action.payload,
        capacityBoardFetchState: 'loaded',
        allProcesses: action.payload.allProcesses,
        selectedProcessId: action.payload.selectedProcessId,
      };
    case TProcessBoardsActionType.FetchCapacityBoardListingFailure:
      return { ...state, capacityBoardFetchState: 'error' };

    case TProcessBoardsActionType.FetchPlanningBoardListing:
      return { ...state, planningBoardFetchState: 'loading' };
    case TProcessBoardsActionType.FetchPlanningBoardListingSuccess:
      return {
        ...state,
        planningBoardInfo: action.payload,
        planningBoardFetchState: 'loaded',
        allProcesses: action.payload.allProcesses,
        selectedProcessId: action.payload.selectedProcessId,
      };
    case TProcessBoardsActionType.FetchPlanningBoardListingFailure:
      return { ...state, planningBoardFetchState: 'error' };

    case TProcessBoardsActionType.FetchOrderTimelineViewBoardListing:
      return { ...state, orderTimelineViewBoardFetchState: 'loading' };
    case TProcessBoardsActionType.FetchOrderTimelineViewBoardListingSuccess:
      return {
        ...state,
        orderTimelineViewBoardInfo: action.payload,
        orderTimelineViewBoardFetchState: 'loaded',
      };
    case TProcessBoardsActionType.FetchOrderTimelineViewBoardListingFailure:
      return { ...state, orderTimelineViewBoardFetchState: 'error' };

    case TProcessBoardsActionType.SetSelectedProcessId:
      return { ...state, selectedProcessId: action.payload };

    default:
      return state;
  }
}
